module.exports = __webpack_public_path__ + "static/media/gsheets.2c0334c5.png";